import { render, staticRenderFns } from "./Attention.vue?vue&type=template&id=5719116e&scoped=true&"
import script from "./Attention.vue?vue&type=script&lang=ts&"
export * from "./Attention.vue?vue&type=script&lang=ts&"
import style0 from "./Attention.vue?vue&type=style&index=0&id=5719116e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5719116e",
  null
  
)

export default component.exports